/**
 * shared/shell.ts — v4 cleanup: typed, minimal, no dead code
 */

const NAV = [
  { href: "/", key: "navHome", label: "Home" },
  { href: "/status/", key: "navStatus", label: "Status" },
] as const;

export function mountShell(): void {
  const host = document.getElementById("app-shell");
  if (!host) return;

  const path = location.pathname.replace(/\/+$/, "") || "/";

  host.innerHTML = `
    <header class="top-bar">
      <a href="/" class="doorpost-logo" aria-label="DOORPOST home">
        <span class="text">DOORPOST</span>
      </a>
      <nav class="site-nav" aria-label="Primary">
        ${NAV.map((item) => {
          const active =
            item.href === "/"
              ? path === "/"
              : path === item.href.replace(/\/$/, "") ||
                path.startsWith(item.href.replace(/\/$/, ""));
          return `<a href="${item.href}" class="nav-link${active ? " is-active" : ""}" data-i18n="${item.key}">${item.label}</a>`;
        }).join("")}
      </nav>
      <div class="controls">
        <button id="lang-toggle" class="control-btn" type="button" aria-label="Switch language">
          <span id="lang-indicator">中</span>
        </button>
        <button id="theme-toggle" class="control-btn" type="button" aria-label="Toggle color theme">
          <svg id="icon-moon" class="is-active" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          <svg id="icon-sun" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" hidden aria-hidden="true"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
        </button>
      </div>
    </header>
  `;
}
